import jwtAxios from "@crema/services/auth/jwt-auth";
import { fetchStart, fetchSuccess, fetchError } from "./Common";
import { CREATE_ROLE_MODULE, GET_MODULES, GET_ROLE, GET_ROLE_MODULES } from "types/actions/roleMaster.action";
import { toastService } from "@crema/core/toast/toastService";

export const getRoles = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    jwtAxios
      .get(`/roles`)
      .then((response) => {
        if (response.status === 200 && response.data.status === "success") {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_ROLE,
            payload: {
              data: response.data.data || [],
              total: response.data.data?.length || 0,
            },
          });
        } else {
          dispatch(fetchError("Something went wrong, please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const getModules = () => {
  return (dispatch: any) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/module")
      .then((response) => {
        if (response.status === 200 && response.data.status === "success") {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_MODULES,
            payload: {
              data: response.data.data,
              total: response.data.data.length,
            },
          });
        } else {
          dispatch(fetchError("Failed to fetch modules."));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const createRoleModule = (body: { role_id: number; module_id: number }) => {
  return (dispatch: any) => {
    dispatch(fetchStart());
    return jwtAxios
      .post("/roleModule", body)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(fetchSuccess());
          if (response.data.message = 'Role-module mapping already exists, updated isActive successfully.') {
            toastService.warning("Role Page Mapping already exists");
          } else {
            toastService.success("Role Page Mapping created successfully!");
          }

          dispatch({
            type: CREATE_ROLE_MODULE,
            payload: response.data,
          });
        } else {
          toastService.error("Role Page mapping unable  create!");
          dispatch(fetchError("Failed to create role-module mapping."));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const getRoleModules = () => {
  return (dispatch: any) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/roleModule")
      .then((response) => {
        if (response.status === 200 && response.data.status === "success") {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_ROLE_MODULES,
            payload: {
              data: response.data.data || [],
              total: response.data.data?.length || 0,
            },
          });
        } else {
          dispatch(fetchError("Failed to fetch role modules."));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const deleteRoleModule = (id: number) => {
  return (dispatch: any) => {
    dispatch(fetchStart());
    return jwtAxios
      .delete(`/roleModule/mappingDeleted/${id}`)
      .then(() => {
        toastService.success("Role Page Mapping removed successfully!");
        dispatch(fetchSuccess());
      })
      .catch((error) => {
        toastService.error("Unable to remove mapping!");
        dispatch(fetchError(error?.message));
      });
  };
};